import React from "react";
import clsx from "clsx";

export default function IndexSwitcher({ current, onChange, canMetals, canTrucks, canBoards }) {
  const tabs = [
    { key: "converters", label: "Converters", visible: true },
    { key: "trucks", label: "Trucks", visible: !!canTrucks },
    { key: "metals", label: "Metals", visible: !!canMetals },
    { key: "boards", label: "Boards", visible: !!canBoards },
  ].filter(t => t.visible);

  if (tabs.length <= 1) return null;

  return (
    <div className="flex gap-2">
      {tabs.map(t => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          className={clsx(
            "px-3 py-2 rounded-xl text-sm font-medium ring-1 ring-emerald-400/20",
            current === t.key
              ? "bg-emerald-600 text-white"
              : "bg-emerald-900/40 text-emerald-50 hover:bg-emerald-900"
          )}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
